/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Price } from './Price';
import {
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
} from './Price';

/**
 * Summary of all gift cards applied to the cart.
 * @export
 * @interface SAPGiftCardSummary
 */
export interface SAPGiftCardSummary {
    /**
     * 
     * @type {Price}
     * @memberof SAPGiftCardSummary
     */
    totalBalance?: Price;
    /**
     * 
     * @type {Price}
     * @memberof SAPGiftCardSummary
     */
    totalAppliedAmount?: Price;
    /**
     * 
     * @type {Price}
     * @memberof SAPGiftCardSummary
     */
    totalRemainingBalance?: Price;
    /**
     * Indicates whether the total value of applied gift cards is sufficient to cover the cart's total amount.
     * @type {boolean}
     * @memberof SAPGiftCardSummary
     */
    giftCardsCoverFullAmount?: boolean;
}

/**
 * Check if a given object implements the SAPGiftCardSummary interface.
 */
export function instanceOfSAPGiftCardSummary(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SAPGiftCardSummaryFromJSON(json: any): SAPGiftCardSummary {
    return SAPGiftCardSummaryFromJSONTyped(json, false);
}

export function SAPGiftCardSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): SAPGiftCardSummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalBalance': !exists(json, 'totalBalance') ? undefined : PriceFromJSON(json['totalBalance']),
        'totalAppliedAmount': !exists(json, 'totalAppliedAmount') ? undefined : PriceFromJSON(json['totalAppliedAmount']),
        'totalRemainingBalance': !exists(json, 'totalRemainingBalance') ? undefined : PriceFromJSON(json['totalRemainingBalance']),
        'giftCardsCoverFullAmount': !exists(json, 'giftCardsCoverFullAmount') ? undefined : json['giftCardsCoverFullAmount'],
    };
}

export function SAPGiftCardSummaryToJSON(value?: SAPGiftCardSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalBalance': PriceToJSON(value.totalBalance),
        'totalAppliedAmount': PriceToJSON(value.totalAppliedAmount),
        'totalRemainingBalance': PriceToJSON(value.totalRemainingBalance),
        'giftCardsCoverFullAmount': value.giftCardsCoverFullAmount,
    };
}

